import { Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import { RequestType } from '../../types/Request.type'
import DrawerContentComments from './content/DrawerContentComments'
import DrawerContentDealer from './content/DrawerContentDealer'
import DrawerContentDefault from './content/DrawerContentDefault'
import DrawerContentInstallation from './content/DrawerContentInstallation'
import DrawerContentPayment from './content/DrawerContentPayment'
import DrawerContentRequestDetails from './content/DrawerContentRequestDetails'
import DrawerContentRequestInfo from './content/DrawerContentRequestInfo'
import DrawerContentStatus from './content/DrawerContentStatus'
import requestDrawerStore from './RequestDrawerStore'

type SingleRequestDrawerProps = {
  setOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>
  openDrawer: boolean
  request: RequestType
}

export const SingleRequestDrawer: FC<SingleRequestDrawerProps> = ({
  openDrawer,
  setOpenDrawer,
  request,
}) => {
  const { mode, setMode, goBack, setWithReportActions } = requestDrawerStore

  const onExit = () => {
    setOpenDrawer((prev) => !prev)
  }

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | string | number | undefined

    if (!openDrawer) {
      timeoutId = setTimeout(() => {
        setMode('default')
        setWithReportActions(false)
      }, 300)
    }

    return () => clearTimeout(timeoutId)
  }, [openDrawer])

  return (
    <RightDrawer
      backButtonClick={() => goBack(onExit)}
      loading={false}
      onClose={onExit}
      onTop={() => {}}
      open={openDrawer}
      title={<DrawerTitle title={`Заявка № ${request.id}`} />}
      titleComp={''}
      isReportDetailsOpen={false}
    >
      {mode === 'default' && (
        <DrawerContentDefault onExit={onExit} request={request} />
      )}
      {mode === 'dealer' && <DrawerContentDealer request={request} />}
      {mode === 'status' && (
        <DrawerContentStatus request={request} onClose={onExit} />
      )}

      {mode === 'payment-type' && <DrawerContentPayment request={request} />}
      {mode === 'installation-data' && (
        <DrawerContentInstallation request={request} onClose={onExit} />
      )}
      {mode === 'data' && (
        <DrawerContentRequestInfo request={request} onClose={onExit} />
      )}
      {mode === 'request-info' && (
        <DrawerContentRequestDetails request={request} onClose={onExit} />
      )}
      {mode === 'comment' && <DrawerContentComments request={request} />}
    </RightDrawer>
  )
}

export const DrawerTitle = ({
  title,
  subtitle,
  hidSubtitle,
}: {
  title: string
  subtitle?: string
  hidSubtitle?: boolean
}) => {
  return (
    <>
      <Typography variant={'subtitle1'} color={'common.white'}>
        <FormattedMessage id={title} />
      </Typography>
      {!hidSubtitle && (
        <Typography variant={'body1'} color={'#8FBFF6'}>
          <FormattedMessage id={subtitle ?? 'Редактирование заявки'} />
        </Typography>
      )}
    </>
  )
}

export default observer(SingleRequestDrawer)
